import React, { Fragment, useContext, useEffect, useState } from "react";
import { SessionContext } from "../../../utility/useSession";
import propTypes from "prop-types";
import { AssetLocation, AssetLocationTypes, KeyManagementTypes } from "../../../logic/api";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import KeyAuditsAtLocation from "../../locations/components/KeyAuditsAtLocation";
import LocationPickerDialog from "../../../components/pickers/locationPicker/LocationPickerDialog";
import flex from "../../../styles/flex";
import { useTranslation } from "react-i18next";

const KeyAuditHistory: React.FunctionComponent<{
  show: boolean;
  onClose: () => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  const [location, setLocation] = useState<AssetLocation | null>();
  const [showLocationPicker, setShowLocationPicker] = useState(false);

  let path = `/`;

  if (session.current.site) {
    if (session.current.site.home) {
      path = `/${session.current.site.home.id}/`;
    }
  }

  if (location != null) {
    path = location.path;
  }

  useEffect(() => {
    if (props.show == true) {
      setLocation(null);
    }
  }, [props.show]);

  const keySelectionTypes = [AssetLocationTypes.Lane, AssetLocationTypes.Zone, AssetLocationTypes.User, AssetLocationTypes.DynamicBox];

  return <Fragment>
    <Dialog fullWidth={true} maxWidth={"md"} open={props.show}>
      <DialogTitle>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {t("keys.labels.auditHistory")}
          <div style={flex.flexRows}>
            <div style={flex.flexFill}>
              {
                location != null && (<b style={{ marginTop: 5, fontSize: 14 }}>{location.parentName} / {location.name}</b>)
              }
            </div>
            <div style={flex.flexAuto}>
              {location != null && (
                <Button onClick={() => {
                  setLocation(null);
                }}>{t("keys.labels.allLocations")}</Button>
              )}
              <Button onClick={() => {
                setShowLocationPicker(true);
              }}>{t("keys.labels.byLocation")}</Button>
            </div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent style={{ overflowY: "scroll", minHeight: 400 }}>
        <KeyAuditsAtLocation path={path}></KeyAuditsAtLocation>
        <LocationPickerDialog
          title={t("keys.labels.selectKeyLocation")}
          show={showLocationPicker}
          displayTypes={[AssetLocationTypes.Zone, AssetLocationTypes.Lane, AssetLocationTypes.Users, AssetLocationTypes.User]}
          selectionTypes={keySelectionTypes}
          keyManagementTypes={[KeyManagementTypes.box, KeyManagementTypes.hook]}
          onChange={(loc) => {
            if (loc == null) {
              setShowLocationPicker(false);
              return;
            }
            setShowLocationPicker(false);
            setLocation(loc);

          }}

        >
        </LocationPickerDialog>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          props.onClose();
        }}>
          {t("general.cancel")}
        </Button>

      </DialogActions>
    </Dialog>
  </Fragment>
}

KeyAuditHistory.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired
}

export default KeyAuditHistory;
